var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StockCompare',[_c('div',{staticClass:"stockview-dashboard"},[_c('div',{staticClass:"columns is-desktop"},[_c('div',{staticClass:"column"},[_c('StockCompareStats',{attrs:{"primary":true}})],1),_c('div',{staticClass:"column"},[_c('StockCompareStats',{attrs:{"primary":false}})],1)]),_c('StockCompareDashboardCharts')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }